// extracted by mini-css-extract-plugin
export default {"header":"MainHeader_header__EQSP1","active":"MainHeader_active__RHETN","dropdown":"MainHeader_dropdown__AEKsG"};